import { Navigate } from "react-router-dom";
import { useAppContext } from "../../hooks/use-app-context";
import SystemCheck from "./system-check";

function ExamSystemCheck() {
  const { examConfig } = useAppContext();
  if (!examConfig) return <Navigate to="/" replace />;
  else return <SystemCheck />;
}

export default ExamSystemCheck;
